import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {Paddock} from "src/app/infrastructure/moovement-api/models/asset";

@Injectable({
  providedIn: 'root'
})
export class PaddockApiClient extends MoovementApiClient {



  update(paddock: Paddock): Observable<Paddock> {
    return this.httpClient.post<Paddock>(`${this.baseUrl}/api/paddock`, paddock);
  }

  delete(paddockId: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.baseUrl}/api/paddock/${paddockId}`);
  }
}
